/** This regexp doesn't consider _punycode_ */
export const urlRegExp =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*[:.][a-z0-9]{2,10}(:[0-9]{1,5})?(\/?.*)?$/;
export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\?.*)*$/;
export const mailtoRegExp =
  /^mailto:(?:(\S+)@([a-zA-Z0-9-]+)(\.)([a-zA-Z]{2,4})(\.?)([a-zA-Z]{0,4})?)?(\?(?=.*(subject|body)=.+).+)?$/;
export const phoneRegExp = /^[0-9 +\-()#,;]+$/;
export const telRegExp = /^tel:(.*)/;
export const numberRegExp = /^-?[0-9]+[.]?[0-9]*$/;
export const timeRegExp = /^(([0-1]?[0-9]|2[0-3]):[0-5][0-9])([AP]M)?/;
export const youtubeIDRegExp =
  /^.*(?:(?:youtu\.be\/)|(?:v\/)|(?:\/u\/\w\/)|(?:embed\/)|(?:watch\?))\??v?=?([^#&?]*).*/;
export const vimeoIDRegExp =
  /^.*(?:vimeo\.com\/)(?:(?:channels\/[A-z]+\/)|(?:groups\/[A-z]+\/videos\/))?([0-9]+)/;
